import { useEffect, useRef, useState } from 'react'
import './loot-keys-landing.styles.scss';
import { Navigate, Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import LootKeysList from './loot-keys-list.component';
import LootKeysForm from './loot-keys-form.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import UpgradeRequiredModal from '@/components/SHARED/upgrade-required-modal/upgrade-required-modal.component';
import { membershipRestrictions, testMemberRestrictions } from '@/utils/membershipRestrictions';
import { getCollectionFromDb } from '@/utils/getDataFromDb';
import { completeGameElementData } from '@/components/PREVIEW/previewGameElements';
import PrintLootKeys from './print-loot-keys.component';
import { useEffectiveMembership } from '@/utils/useEffectiveMembership';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';


const LootKeysLandingPage = ({
  gameElements,
  gameStats,
  gameData,
  playerList,
  role
}) => {

  const membership = useEffectiveMembership();
  const [showUpgradeModal, setShowUpgradeModal] = useState(null);
  const [lootKeysFromDb, setLootKeysFromDb] = useState({});
  const lootKeysRef = useRef();
  const lootKeysListenerRef = useRef();
  const navigate = useNavigate();
  const location = useLocation();

  const gameId = gameData?.gameId;
  const isPreview = location.pathname.includes('/preview/manager/');

  useEffect(() => {
    if (!gameData?.gameName) return;
    changeDocumentTitle(`Loot Keys | Manage ${gameData.gameName}`);
  }, [gameData?.gameName])

  useEffect(() => {
    if (!gameData || !membership) return;
    checkMembership();

    function checkMembership() {
      const element = 'lootKeys'
      const res = testMemberRestrictions({ 'gameData': gameData, 'membership': membership, 'element': element })
      // console.log(res);

      if (res.disabled && membershipRestrictions) {
        let message = ''
        const planRest = membershipRestrictions[membership.membership];
        if (res.disabledReason.includes(element)) {
          message = `While using the ${planRest.title}, you are not able to access Loot Keys.`;
        }
        setShowUpgradeModal(message)
        return;
      }
    }

  }, [gameData, membership])

  useEffect(() => {
    if (!gameId) return;
    getGameElementsToManage();

    function getGameElementsToManage() {
      if (isPreview) {
        const lootKeyObj = {};
        if (!completeGameElementData) return;
        Object.values(completeGameElementData)
          .filter(e => e.type === 'lootKey' && e.status === 'active')
          .forEach(e => {
            lootKeyObj[e.id] = e;
          });
        setLootKeysFromDb(lootKeyObj);
        return;
      }
      getCollectionFromDb({
        "collection": `games/${gameId}/gameElements`,
        "query1": {
          "key": "type",
          "condition": "==",
          "value": "lootKey"
        },
        "callback": callback,
        "handleListener": handleListener
      })
      function callback(data) {
        console.log(data);
        lootKeysRef.current = {
          ...lootKeysRef.current,
          ...{ [data.id]: data }
        }
        setLootKeysFromDb(lootKeysRef.current);
      }
      function handleListener(unsub) {
        console.log('setting listener');
        lootKeysListenerRef.current = unsub;
      }
    }

    return () => {
      if (lootKeysListenerRef.current) {
        console.log('destroying listener');
        lootKeysListenerRef.current();
        lootKeysListenerRef.current = null;
      }
    }
  }, [gameId, isPreview])

  return (
    <div className='loot-keys-landing'>
      <Routes>
        <Route path='' element={
          <div className='g-card loot-keys-card'>
            <BackButton cancel={() => navigate(-1)} />
            <div className="g-space-1"></div>
            <div className='card-title'>
              <ImageContainer src='/images/icons/lootkey.png' alt='loot keys icon' className='head-icon' />
              Create and Edit Loot Keys
            </div>
            <hr />
            <div className='loot-keys-landing-content'>
              <LootKeysList
                gameElements={gameElements}
                lootKeysFromDb={lootKeysFromDb}
                gameData={gameData}
                playerList={playerList}
                role={role}
              />
            </div>
          </div>
        }></Route>
        <Route path='create' element={
          <LootKeysForm
            gameElements={gameElements}
            lootKeysFromDb={lootKeysFromDb}
            gameData={gameData}
            gameStats={gameStats}
            playerList={playerList}
            role={role} />
        }></Route>
        <Route path='edit/:lootKeyPath' element={
          <LootKeysForm
            gameElements={gameElements}
            lootKeysFromDb={lootKeysFromDb}
            gameData={gameData}
            gameStats={gameStats}
            playerList={playerList}
            role={role} />
        }></Route>
        <Route path='print-loot-keys' element={
          <PrintLootKeys />
        }></Route>
        <Route path="*" element={<Navigate replace to="/404" />} />
      </Routes>
      <UpgradeRequiredModal
        show={showUpgradeModal}
        cancel={() => setShowUpgradeModal(null)}
        message={showUpgradeModal}
      />
    </div>
  )
}

export default LootKeysLandingPage